import { Component, OnInit } from '@angular/core';
import { FunctionsService } from "../../services/functions.service";
import { environment } from '../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
    providers: [NgxSpinnerService]
})

export class PrivacyPolicyComponent implements OnInit {
    termsConditionsUrl = environment.termsConditions;

    constructor(
        private translate: TranslateService,
        public functionsService: FunctionsService
    ) { 
        this.translate.setDefaultLang('en');
        this.functionsService.setTitle('register.privacy_policy');
    }

    async ngOnInit() {
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguage(localStorage.getItem('language'));
        }else{ //If the language is not specified, use default one.
            this.functionsService.useLanguage('en');
        }
    }
}